interface Props {
  onAllow: () => void;
  onDismiss: () => void;
}

export default function NotificationPermissionDialog({ onAllow, onDismiss }: Props) {
  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
      <div className="bg-gray-800 rounded-xl max-w-sm w-full p-6 space-y-4">
        <h2 className="text-xl font-semibold text-center">Povolit notifikace?</h2>

        <p className="text-gray-300 text-center">
          Upozorníme tě, když tvoje hladina alkoholu překročí nastavený limit - i když budeš mít telefon v kapse.
        </p>

        <div className="flex flex-col gap-3 pt-2">
          <button
            onClick={onAllow}
            className="w-full py-3 bg-beer hover:bg-beer-dark rounded-lg font-medium transition-colors"
          >
            Povolit notifikace
          </button>
          <button
            onClick={onDismiss}
            className="w-full py-2 text-gray-400 hover:text-gray-200 transition-colors"
          >
            Teď ne
          </button>
        </div>
      </div>
    </div>
  );
}
